const activityPage = {
  "activity.no-data.title": "Bienvenido a Be Your Best Pro",
  "activity.no-data.subtitle": "Empieza a entrenar en VR hoy y sigue tu progreso aquí.",
  "activity.hero.title": "Tu actividad",
  "activity.hero.subtitle": "Cada sesión cuenta parte de tu historia, desde tu historial de entrenamiento hasta tus insights de rendimiento.",
  "activity.empty.title": "Aún no hay sesiones completadas",
  "activity.empty.subtitle": "Completa una sesión en VR y tus resultados aparecerán aquí.",
  "activity.load-more": "Cargar más sesiones",
};

const activityPageMobile = {
  "activity.latest.title": "Último",
  "activity.journal.title": "Diario",
  "activity.journal.view-session": "Ver sesión",
};

export const activity = {
  ...activityPage,
  ...activityPageMobile,
};
